"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ravenJs = _interopRequireDefault(require("raven-js"));

var _version = _interopRequireDefault(require("../../constants/version"));

var _config = require("../../utils/config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 上报
var report = function report() {
  return function (_ref) {
    var url = _ref.url,
        data = _ref.data;

    // 复用raven 所以这里要适配raven
    var _getConfig = (0, _config.getConfig)(),
        isReport = _getConfig.isReport,
        serviceId = _getConfig.serviceId; // 一般来说生产环境才需要上报


    if (!isReport) return true;
    var opts = {
      url: url,
      data: data,
      auth: {
        service_id: serviceId,
        kepler_version: _version.default
      },
      options: {}
    };
    return _ravenJs.default._makeRequest(opts);
  };
};

var _default = report;
exports.default = _default;